import { render, staticRenderFns } from "./GradeAdd.vue?vue&type=template&id=067edbdd&scoped=true"
import script from "./GradeAdd.vue?vue&type=script&lang=js"
export * from "./GradeAdd.vue?vue&type=script&lang=js"
import style0 from "./GradeAdd.vue?vue&type=style&index=0&id=067edbdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067edbdd",
  null
  
)

export default component.exports